import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/globals.css"; // Your custom styles if any
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import './index.css';
import { SessionProvider } from "next-auth/react";

config.autoAddCss = false;

export default function MyApp({ Component, pageProps }) {
  return (
    <SessionProvider session={pageProps.session}>
      <Component {...pageProps} />
    </SessionProvider>
  );
}